import type { CityConfig } from "../city-template/types";

export const highlandsRanchConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Highlands Ranch",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "highlands-ranch",
  route: "/highlands-ranch",
  title: "Emergency Passport Highlands Ranch, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Highlands Ranch, Colorado — as fast as 24 hours. Same-day courier processing for Highlands Ranch, Littleton, Lone Tree, Castle Rock, and all Douglas County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Highlands Ranch, CO",
  heroSubtitle: "Business trip to Europe next week and your passport expired? Family vacation to Mexico in 10 days and the kids need first-time passports? We help Highlands Ranch residents — from master-planned community families to Douglas County professionals to south metro commuters — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Highlands%20Ranch%20Colorado%20suburban%20community%20with%20the%20iconic%20Highlands%20Ranch%20Mansion%20on%20a%20hilltop%20against%20the%20Rocky%20Mountain%20Front%20Range%20backdrop%2C%20master%20planned%20neighborhoods%20with%20greenbelts%20and%20walking%20trails%20winding%20through%20residential%20areas%2C%20the%20Civic%20Green%20Park%20with%20its%20distinctive%20amphitheater%20and%20water%20features%2C%20the%20Denver%20metro%20skyline%20visible%20in%20the%20distance%2C%20warm%20afternoon%20light%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20wide%20cinematic%20perspective&width=1800&height=700&seq=highlands-ranch-hero-001&orientation=landscape",
  heroImageAlt: "Highlands Ranch Colorado with mansion, Front Range backdrop, and suburban community",
  geoPosition: "39.5420;-104.9703",
  geoPlacename: "Highlands Ranch, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 25 miles northeast via I-25 and C-470 — about 30 minutes",
  },
  nearbyCitiesZips: [
    { name: "Highlands Ranch", zips: "80126, 80129, 80130, 80163" },
    { name: "Littleton", zips: "80120, 80121, 80122, 80123, 80125, 80126, 80127, 80128, 80129, 80130" },
    { name: "Lone Tree", zips: "80124, 80134" },
    { name: "Castle Rock", zips: "80104, 80108, 80109" },
    { name: "Centennial", zips: "80015, 80016, 80111, 80112, 80121, 80122" },
    { name: "Parker", zips: "80134, 80138" },
    { name: "Greenwood Village", zips: "80111, 80112, 80121" },
    { name: "Englewood", zips: "80110, 80111, 80112, 80113" },
    { name: "Sedalia", zips: "80135" },
    { name: "Roxborough Park", zips: "80125" },
    { name: "Louviers", zips: "80131" },
    { name: "Denver Tech Center", zips: "80111, 80112" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Highlands Ranch international departures via DEN" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — skip the Denver agency entirely" },
    { icon: "ri-flight-takeoff-line", title: "DEN Airport Service", desc: "Same-day courier for Denver International Airport — just 40 miles from Highlands Ranch" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in Highlands Ranch, Littleton, or Lone Tree" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/denver" },
    { name: "Emergency passport help in Castle Rock, CO", route: "/castle-rock" },
    { name: "Fast passport renewal in Douglas County", route: "/highlands-ranch" },
    { name: "Urgent passport services for Lone Tree and Littleton", route: "/highlands-ranch" },
    { name: "Colorado passport services overview", route: "/colorado" },
    { name: "Passport courier services in Centennial and Parker", route: "/highlands-ranch" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Highlands Ranch remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Although the Colorado Passport Agency is only 25 miles from Highlands Ranch, our courier service saves you the hassle of appointments, C-470 traffic, and the drive to Aurora. Let us handle the logistics while you focus on your travel plans.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of Highlands Ranch, Douglas County, and the south Denver metro",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Highlands Ranch and the south Denver metro. From the original Ranch neighborhoods to the newer Eastridge and Backcountry communities, from the Town Center to every master-planned subdivision — we serve all 100,000+ Highlands Ranch residents and the surrounding south metro area.",
  nearbyCitiesIntro: "We serve Highlands Ranch and all nearby south metro communities including Littleton, Lone Tree, Castle Rock, Centennial, Parker, Greenwood Village, Englewood, Sedalia, and Roxborough Park. We also serve the entire C-470 corridor and Douglas County.",
  howItWorksIntro: "Most Highlands Ranch travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — convenient even though the Colorado Passport Agency is only 25 miles away.",
  mistakesIntro: "Highlands Ranch is Colorado's largest master-planned community and one of the state's most family-oriented areas. The combination of frequent international travel by professionals and first-time passport needs for families creates unique challenges. Here are the most common mistakes we see.",
  testimonialsIntro: "Highlands Ranch residents — from commuting professionals to busy families to Douglas County locals — trust us when international travel is imminent and deadlines are tight.",
  faqIntro: "Have questions about expedited passports in Highlands Ranch, CO? Here are the most common ones we hear from south Denver metro travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Aurora (25 miles, 30 minutes each way)", "Appointment scheduling 2–3 weeks out"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver agency drive required — ship from Highlands Ranch", "Perfect for family travel, business trips, and vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Highlands Ranch travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service without agency appointments or Denver traffic.",
      bullets: ["24–48 hour turnaround available", "DEN airport departure support", "Family and business travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Highlands Ranch adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Highlands Ranch address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Highlands Ranch residents — especially popular with families getting kids their first passports.",
      bullets: ["Acceptance facility scheduling in Highlands Ranch or Littleton", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Highlands Ranch residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — Highlands Ranch is one of Colorado's most family-oriented communities and this is our most requested service.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Highlands Ranch and Douglas County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Highlands Ranch CO", description: "Urgent passport processing for Highlands Ranch Colorado travelers with immediate departure needs from DEN." },
    { name: "Expedited Passport Renewal Highlands Ranch CO", description: "Fast passport renewal for Highlands Ranch Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Highlands Ranch CO", description: "New passport application services for Highlands Ranch Colorado residents applying for their first passport." },
    { name: "Child Passport Highlands Ranch CO", description: "Minor passport services for Highlands Ranch Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "The Anderson Family",
      location: "Highlands Ranch, CO — Westridge",
      rating: 5,
      text: "Family trip to Italy over spring break. Four passports — two renewals and two first-time for the kids. Done in 5 business days. With working parents and school schedules, not having to drive to Denver was a game changer.",
      service: "Family Passport Bundle",
    },
    {
      name: "Brian K.",
      location: "Highlands Ranch, CO — Eastridge",
      rating: 5,
      text: "Business trip to Singapore with one week notice. Fast Passport Center got my renewal done in 3 days. The dedicated agent was incredibly responsive and the daily updates kept me informed.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer M.",
      location: "Lone Tree, CO",
      rating: 5,
      text: "My daughter needed her first passport for a school trip to Costa Rica. We had 10 days. Fast Passport Center handled everything and we had her passport in 4 days. Incredible service for south metro families.",
      service: "First-Time Passport",
    },
    {
      name: "David R.",
      location: "Highlands Ranch, CO — Town Center",
      rating: 5,
      text: "Lost my passport a week before a trip to London. Fast Passport Center replaced it in 48 hours. The peace of mind from having a dedicated agent and daily updates was worth every penny.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "hlr-1",
      name: "Highlands Ranch Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "9609 S University Blvd",
      city: "Highlands Ranch",
      state: "CO",
      zip: "80126",
      phone: "(303) 791-3261",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Highlands Ranch, near University Boulevard and Highlands Ranch Parkway",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Highlands Ranch acceptance facility with extended hours. Serves over 100,000 residents — book appointments 2–3 weeks in advance. One of the busiest suburban Denver locations.",
      icon: "ri-mail-line",
    },
    {
      id: "hlr-2",
      name: "Littleton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "5753 S Prince St",
      city: "Littleton",
      state: "CO",
      zip: "80120",
      phone: "(303) 798-1020",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Downtown Littleton, approximately 5 miles northwest of Highlands Ranch",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Larger facility than Highlands Ranch with more appointment slots. Extended hours until 5PM. Good alternative when Highlands Ranch is booked.",
      icon: "ri-mail-line",
    },
    {
      id: "hlr-3",
      name: "Douglas County Clerk — Castle Rock",
      type: "County Clerk Passport Acceptance",
      address: "301 Wilcox St",
      city: "Castle Rock",
      state: "CO",
      zip: "80104",
      phone: "(303) 660-7469",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Castle Rock, approximately 15 miles south of Highlands Ranch via I-25",
      website: "https://www.douglas.co.us/",
      websiteLabel: "Douglas County Clerk",
      notes: "County clerk with full-service passport acceptance. Extended hours. Good for Douglas County residents who want to avoid post office crowds. Approximately 20-minute drive from Highlands Ranch.",
      icon: "ri-government-line",
    },
    {
      id: "hlr-4",
      name: "Centennial Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7340 S Alton Way",
      city: "Centennial",
      state: "CO",
      zip: "80112",
      phone: "(303) 770-1020",
      hours: "Mon–Fri: 9:00 AM – 5:00 PM",
      distance: "Centennial, approximately 10 miles north of Highlands Ranch via I-25",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Large facility serving the Denver Tech Center area. Good appointment availability. Convenient for northern Highlands Ranch residents.",
      icon: "ri-mail-line",
    },
    {
      id: "hlr-5",
      name: "Lone Tree Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10001 Park Meadows Dr",
      city: "Lone Tree",
      state: "CO",
      zip: "80124",
      phone: "(303) 708-8830",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Lone Tree, approximately 5 miles east of Highlands Ranch",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Highlands Ranch residents near the C-470 corridor. Located near Park Meadows Mall. Good parking.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 25-mile drive to Aurora on C-470", fpc: "No — ship from Highlands Ranch" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Family-Friendly", agency: "Difficult with kids — agency won't allow extra visitors", fpc: "No travel needed — perfect for families" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until School Break to Apply",
      description: "Highlands Ranch families often realize during winter or spring break planning that passports are needed. Summer is peak passport season with 8–11 week routine processing. Start expedited service at least 4 weeks before your departure date.",
    },
    {
      icon: "ri-parent-line",
      title: "Both Parents Not Present for Child Passports",
      description: "For children under 16, both parents must appear in person at the acceptance facility. This is the #1 rejection reason for Highlands Ranch families. Plan accordingly — mom and dad both need to be at the appointment.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photos",
      description: "Multiple local photo options exist (Walgreens, UPS Store, Costco) but not all produce compliant photos. Passport photos must be 2×2 inches on a white background — no school photos, no cropped family photos.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Using County Clerk for Faster Appointments",
      description: "Many Highlands Ranch residents only consider the post office. The Douglas County Clerk in Castle Rock (15 miles south) often has better availability and extended hours. This is especially useful during peak family travel seasons.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking All Family Members' Passports",
      description: "In family-oriented Highlands Ranch, it's common to book international travel only to discover one family member's passport is expired or has insufficient validity. Check ALL passports before booking.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Assuming DEN Is the Only Option",
      description: "While DEN is Colorado's primary international airport, Colorado Springs Airport (COS) is only 60 miles south and sometimes offers better domestic connections for international itineraries. Always check all regional airport options.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Highlands Ranch or Douglas County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Highlands Ranch, Littleton, or Lone Tree." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document — we catch family application errors before they cause rejections." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no C-470 drive to Aurora needed." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passports back to your Highlands Ranch address — ready for your family adventure." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Highlands Ranch, CO?", a: "Fast Passport Center offers emergency passport processing in Highlands Ranch, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 25-mile drive to the Colorado Passport Agency in Aurora." },
    { q: "Can you help with family passports — multiple kids plus parents?", a: "Absolutely — this is our specialty for Highlands Ranch. As Colorado's largest master-planned community, we handle more family passport bundles here than almost anywhere else. We can process multiple renewals and first-time passports simultaneously, with document review for every family member." },
    { q: "Is Highlands Ranch served by the Colorado Passport Agency?", a: "Highlands Ranch is 25 miles from the Colorado Passport Agency (7245 S Havana Street Suite B-600, Centennial, CO 80112). However, the agency requires appointments booked 2–3 weeks in advance and only handles life-or-death emergencies. For most south metro families, our courier service is faster and more convenient." },
    { q: "What if I live in Littleton, Lone Tree, or Castle Rock?", a: "Fast Passport Center serves all of the south Denver metro including Littleton, Lone Tree, Castle Rock, Centennial, Parker, Greenwood Village, Englewood, and all Douglas County communities. Our service works identically everywhere in the south metro." },
    { q: "Both parents work — how do we handle the in-person requirement for kids' passports?", a: "For first-time child passports, both parents must appear at the acceptance facility. We recommend the Douglas County Clerk in Castle Rock (extended hours until 5PM) or the Littleton Post Office (also open until 5PM). Book appointments 2–3 weeks ahead. Once the acceptance step is done, our couriers handle everything else.",
    },
    { q: "How much does an expedited passport cost in Highlands Ranch, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Children's passports are $100 + $35 acceptance fee. Fast Passport Center's service fees vary by processing speed. Contact us for a family quote.",
    },
    { q: "Where can I get passport photos in Highlands Ranch?", a: "Walgreens (6650 Timberline Rd), UPS Store (9579 S University Blvd), and Costco (Lone Tree) all offer passport photo services. The CVS at 9457 S University Blvd also provides photos. All are within 10 minutes of most Highlands Ranch neighborhoods.",
    },
    { q: "Do you serve the Denver Tech Center and business travelers in Highlands Ranch?", a: "Yes. Many Highlands Ranch residents work in the Denver Tech Center (DTC) just 10 minutes north. Fast Passport Center serves business travelers with tight deadlines, providing rush passport services that work around demanding professional schedules.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Highlands Ranch", address: "6650 Timberline Rd, Highlands Ranch, CO 80130", hours: "Mon–Sun: 8AM–9PM", website: "https://www.walgreens.com/" },
    { name: "UPS Store — Highlands Ranch", address: "9579 S University Blvd, Highlands Ranch, CO 80126", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "CVS — Highlands Ranch", address: "9457 S University Blvd, Highlands Ranch, CO 80126", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/" },
    { name: "Costco — Lone Tree", address: "8686 Park Meadows Center Dr, Lone Tree, CO 80124", hours: "Mon–Fri: 10AM–8:30PM, Sat: 9:30AM–6PM, Sun: 10AM–6PM", website: "https://www.costco.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Lone Tree (Douglas County)", address: "9350 Heritage Hills Cir, Lone Tree, CO 80124", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Douglas County residents. REAL ID and driver's license renewals. Approximately 5 miles from Highlands Ranch. Convenient south metro location.", featured: true },
    { name: "DMV — Littleton (Arapahoe County)", address: "5334 S Prince St, Littleton, CO 80120", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for northern Douglas County residents. REAL ID processing available. Approximately 5 miles from Highlands Ranch.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "40 miles northeast of Highlands Ranch via C-470 and Pena Blvd",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport. Approximately 40–50 minute drive from Highlands Ranch. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. The closest international airport for south metro residents.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "60 miles south of Highlands Ranch via I-25",
      address: "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916",
      note: "Alternative airport with domestic service. Approximately 1-hour drive from Highlands Ranch. Sometimes offers better connections and fares than DEN.",
      flightUrl: "https://www.flycos.com/",
      flightLabel: "COS Flight Info",
      featured: false,
    },
    {
      code: "APA",
      name: "Centennial Airport",
      distance: "15 miles east of Highlands Ranch via C-470",
      address: "7800 S Peoria St, Englewood, CO 80112",
      note: "General aviation and corporate airport — one of the busiest general aviation airports in the U.S. No commercial passenger service. Convenient for private and corporate travel departures.",
      flightUrl: "https://www.centennialairport.com/",
      flightLabel: "APA Flight Info",
      featured: false,
    },
  ],
};